export default __webpack_public_path__ + "static/media/stop_auto.295069ce.svg";